import { render, staticRenderFns } from "./CurrencyField.vue?vue&type=template&id=517cc7f8&scoped=true&"
import script from "./CurrencyField.vue?vue&type=script&lang=js&"
export * from "./CurrencyField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517cc7f8",
  null
  
)

export default component.exports